import { render, staticRenderFns } from "./GoalCardShell.vue?vue&type=template&id=c0316ae8&scoped=true"
import script from "./GoalCardShell.vue?vue&type=script&lang=js"
export * from "./GoalCardShell.vue?vue&type=script&lang=js"
import style0 from "./GoalCardShell.vue?vue&type=style&index=0&id=c0316ae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0316ae8",
  null
  
)

export default component.exports